import React from "react";
import OrderStatus from "pages/OrderStatus/OrderStatus";

function OrderPaid() {
  return <OrderStatus type="PAID" />;
}

export default OrderPaid;
